import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl} from "@angular/forms";
import {AccountsService} from "../../../services/accounts.service";
import {AuthenticationService, AlertService, LoaderService} from "../../../services/index";
import {ActivatedRoute, Params, Router} from "@angular/router";
import * as $ from 'jquery';
import {LocationList} from '../../../models/location';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.css']
})

export class AccountsComponent implements OnInit {
  private moneyRegex = '^([0-9]+|[0-9]*(\.[0-9])([1-9])?)$';
  private accountsForm;
  private accountsFormObject;
  private loading = false;
  private id;
  private locations;
  private senderCity = [];
  private receiverCity = [];
  statesList = [];
  countryList = [];
  cityList = [];

  constructor(private formBuilder:FormBuilder,
              private accountsService:AccountsService,
              private authenticationService:AuthenticationService,
              private alertService:AlertService,
              private loaderService:LoaderService,
              private router:Router,
              private route:ActivatedRoute) {
  }

  ngOnInit() {
    this.locations = LocationList;
    // this.countryList = this.locations.map(l=>l.country);
    // this.countryList = this.countryList.filter(function (elem, index, self) {
    //   return index === self.indexOf(elem);
    // })

    this.cityList = [].concat.apply([], this.locations.map(l=>l.city));

    this.route.queryParams.forEach((params:Params) => {
      this.id = params['id'];
    });
    this.id ? this.loaderService.loading(true) : null;
    this.accountsForm = this.formBuilder.group({
      name: ['', Validators.required],
      gstin: [''],
      mobile_number: ['', Validators.pattern('^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$')],
      contact_name: ['', Validators.required],
      address: [''],
      country: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      email: [''],
      weight_range_rate: this.formBuilder.array([
        this.initWeightRange(0, 100, 0),
        this.initWeightRange(101, 300, 0),
        this.initWeightRange(301, 500, 0),
        this.initWeightRange(501, 1000, 0),
        this.initWeightRange(1001, '+', 0)
      ]),
      weight_range_rate_cross: this.formBuilder.array([
        this.initWeightRange(0, 100, 0),
        this.initWeightRange(101, 300, 0),
        this.initWeightRange(301, 500, 0),
        this.initWeightRange(501, 1000, 0),
        this.initWeightRange(1001, '+', 0)
      ]),
      weight_range_rate_mumbai: this.formBuilder.array([
        this.initWeightRange(0, 100, 0),
        this.initWeightRange(101, 300, 0),
        this.initWeightRange(301, 500, 0),
        this.initWeightRange(501, 1000, 0),
        this.initWeightRange(1001, '+', 0)
      ]),
      weight_range_rate_roi: this.formBuilder.array([
        this.initWeightRange(0, 100, 0),
        this.initWeightRange(101, 300, 0),
        this.initWeightRange(301, 500, 0),
        this.initWeightRange(501, 1000, 0),
        this.initWeightRange(1001, '+', 0)
      ])
    });
    this.id ? this.accountsService.getById(this.id).subscribe(
      data => {
        this.accountsFormObject = data[0] || {};
        this.accountsForm.patchValue(data[0]);

        setTimeout(()=> {
          data[0].city ? this.accountsForm.patchValue({city: data[0].city}) : null;
          this.loaderService.loading(false);
        }, 800);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      }) : this.accountsFormObject = {};

    this.accountsForm.controls['country'].valueChanges.subscribe(value => {
      // !this.loading ?
      //   this.statesList = this.locations.map(l=>l.country == value ? l.state : null) : null;
      // this.accountsForm.patchValue({state: '', city: ''});
    });
    this.accountsForm.controls['state'].valueChanges.subscribe(value => {
      // !this.loading ?
      //   this.cityList = (this.locations.find(l=>l.country == this.accountsForm.controls['country'].value && l.state == value) || {"city": []}).city : null;
    });
    this.accountsForm.controls['city'].valueChanges.subscribe(value => {
      var locationDetails = this.locations.find(location=>location.city.indexOf(value) > -1) || {
          country: '',
          state: ''
        };
      locationDetails ? this.accountsForm.patchValue({
        country: locationDetails.country,
        state: locationDetails.state
      }) : null;
    });
    !this.id ? this.accountsForm.patchValue({country: 'India'}) : null;
    !this.id ? this.accountsForm.patchValue({state: 'Gujarat'}) : null;
  }

  formatter = (result:string) => `${result} (${this.locations.find(location=>location.city.indexOf(result) > -1).state})`;

  searchCountry = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 1 ? []
        : this.countryList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  searchState = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 1 ? []
        : this.statesList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  searchCity = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term =>term.length < 3 ? [] : this.cityList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1));


  initWeightRange(start, end, amount) {
    return this.formBuilder.group({
      start: [start, Validators.required],
      end: [end, Validators.required],
      amount: [amount, [Validators.pattern(this.moneyRegex), Validators.required]]
    });
  }

  validateAllFormFields(formGroup:FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    $(document).ready(function () {
      $('html, body').animate({
        scrollTop: $('.alert-danger').closest('.form-group').offset().top - 56
      }, 500);
    });
  }

  submitAccountsBooking() {
    // Object.keys(this.accountsForm.controls).forEach((k)=> {
    //   console.log(k, ' = ', this.accountsForm.controls[k].value, ' - ', this.accountsForm.controls[k].valid);
    // });
    this.accountsForm.valid ? this.createNewAccount(this.accountsForm.value) : this.validateAllFormFields(this.accountsForm);
  }

  createNewAccount(value) {
    this.loading = true;
    !this.accountsFormObject._id ? value['created_by'] = this.authenticationService.user()._id : null;
    this.accountsFormObject._id ? this.accountsService.putById(this.accountsFormObject._id, value)
      .subscribe(
        data => {
          this.alertService.success('Account Updated...', true);
          this.accountsForm.reset();
          this.accountsFormObject = {};
          this.router.navigate(['/accounts_list']);
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        })
      : this.accountsService.create(value)
      .subscribe(
        data => {
          this.alertService.success('Account Generated...', true);
          this.accountsForm.reset();
          this.loading = false;
          this.accountsForm.patchValue({
            weight_range_rate: [
              {start: 0, end: 100, amount: 0},
              {start: 101, end: 300, amount: 0},
              {start: 301, end: 500, amount: 0},
              {start: 501, end: 1000, amount: 0},
              {start: 1001, end: '+', amount: 0}
            ],
            weight_range_rate_cross: [
              {start: 0, end: 100, amount: 0},
              {start: 101, end: 300, amount: 0},
              {start: 301, end: 500, amount: 0},
              {start: 501, end: 1000, amount: 0},
              {start: 1001, end: '+', amount: 0}
            ],
            weight_range_rate_mumbai: [
              {start: 0, end: 100, amount: 0},
              {start: 101, end: 300, amount: 0},
              {start: 301, end: 500, amount: 0},
              {start: 501, end: 1000, amount: 0},
              {start: 1001, end: '+', amount: 0}
            ],
            weight_range_rate_roi: [
              {start: 0, end: 100, amount: 0},
              {start: 101, end: 300, amount: 0},
              {start: 301, end: 500, amount: 0},
              {start: 501, end: 1000, amount: 0},
              {start: 1001, end: '+', amount: 0}
            ]
          })
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/accounts/accounts/accounts.component.ts